import { render, staticRenderFns } from "./Anchor.vue?vue&type=template&id=8ba316d8&scoped=true"
import script from "./Anchor.vue?vue&type=script&lang=js"
export * from "./Anchor.vue?vue&type=script&lang=js"
import style0 from "./Anchor.vue?vue&type=style&index=0&id=8ba316d8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba316d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ba316d8')) {
      api.createRecord('8ba316d8', component.options)
    } else {
      api.reload('8ba316d8', component.options)
    }
    module.hot.accept("./Anchor.vue?vue&type=template&id=8ba316d8&scoped=true", function () {
      api.rerender('8ba316d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/payments/Anchor.vue"
export default component.exports